import { render, staticRenderFns } from "./OldSurgeries.vue?vue&type=template&id=43b9ebfe"
import script from "./OldSurgeries.vue?vue&type=script&lang=js"
export * from "./OldSurgeries.vue?vue&type=script&lang=js"
import style0 from "./OldSurgeries.vue?vue&type=style&index=0&id=43b9ebfe&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports